import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['select', 'quiz', 'poll', 'open', 'sortable', 'likert', 'container']

  connect() {
    this.selected()
  }

  selected() {
    this.hideFields()

    switch (this.selectTarget.value) {
      case 'Question::Quiz':
        if (this.hasQuizTarget) {
          this.containerTarget.innerHTML = this.quizTarget.innerHTML
        }
        // this.choiceTarget.classList.remove('hidden')
        break;
      case 'Question::Poll':
        if (this.hasPollTarget) {
          this.containerTarget.innerHTML = this.pollTarget.innerHTML
        }
        // this.choiceTarget.classList.remove('hidden')
        break;
      case 'Question::Open':
        if (this.hasOpenTarget) {
          this.containerTarget.innerHTML = this.openTarget.innerHTML
        }
        // this.openTarget.classList.remove('hidden')
        break;
      case 'Question::Sortable':
        if (this.hasSortableTarget) {
          this.containerTarget.innerHTML = this.sortableTarget.innerHTML
        }
        // this.sortableTarget.classList.remove('hidden')
        break;
      case 'Question::Likert':
        if (this.hasLikertTarget) {
          this.containerTarget.innerHTML = this.likertTarget.innerHTML
        }
        break;
      default:
        break;
    }
  }

  hideFields() {
    if (this.hasQuizTarget) {
      this.quizTarget.classList.add('hidden')
    }
    if (this.hasPollTarget) {
      this.pollTarget.classList.add('hidden')
    }
    if (this.hasOpenTarget) {
      this.openTarget.classList.add('hidden')
    }
    if (this.hasSortableTarget) {
      this.sortableTarget.classList.add('hidden')
    }
    if (this.hasLikertTarget) {
      this.likertTarget.classList.add('hidden')
    }
  }
}
